/*@flow*/
import {
  GET_PLACE_METRICS,
  GET_PLACEMETRICS_ORDER,
  GET_SELECTED_METRICS,
} from './definitions';
import type { PlaceMetricCreateInput } from './__generated__/CreatePlaceMetric';

const mkId = () => Math.round(Math.random() * 1000);

interface Cache {
  readQuery(any): any;
  writeQuery(any): any;
}

export default {
  Mutation: {
    updateSelectedMetrics(
      _: any,
      { input }: { input: { ids: string[] } },
      { cache }: { cache: Cache }
    ): Promise<void> {
      const query = GET_SELECTED_METRICS;
      const data = { selectedMetrics: input.ids };
      cache.writeQuery({ query, data });
      return Promise.resolve();
    },
    updatePlaceMetricsOrder(
      _: any,
      { input }: { input: { ids: string[] } },
      { cache }: { cache: Cache }
    ): Promise<void> {
      const query = GET_PLACEMETRICS_ORDER;
      const data = { placeMetricsOrder: input.ids };
      cache.writeQuery({ query, data });
      return Promise.resolve();
    },
    createPlaceMetric(
      _: any,
      { input }: { input: PlaceMetricCreateInput },
      { cache }: { cache: Cache }
    ) {
      const record = {
        ...input,
        id: mkId(),
        analysis: { ...input.analysis, id: mkId() },
      };

      const previous = cache.readQuery({ query: GET_PLACE_METRICS });

      const data = {
        me: {
          company: {
            placeMetrics: [record, ...previous.me.company.placeMetrics],
          },
        },
      };

      cache.writeQuery({ query: GET_PLACE_METRICS, data });

      return Promise.resolve({
        success: true,
        record,
        errors: [],
      });
    },
    updatePlaceMetric(
      _: any,
      { input }: { input: { id: string } },
      { cache }: { cache: Cache }
    ): Promise<{|errors: Array<any>, record: {id: string, ...}, success: boolean|}> {
      const previous = cache.readQuery({ query: GET_PLACE_METRICS });
      const placeMetrics = previous.me.company.placeMetrics.map(v => {
        if (String(v.id) !== String(input.id)) {
          return v;
        }
        return input;
      });
      const data = {
        me: {
          company: {
            placeMetrics,
          },
        },
      };
      cache.writeQuery({ query: GET_PLACE_METRICS, data });
      return Promise.resolve({
        success: true,
        record: input,
        errors: [],
      });
    },
    destroyPlaceMetric(
      _: any,
      { input }: { input: { id: string } },
      { cache }: { cache: Cache }
    ): Promise<{|errors: Array<any>, success: boolean|}> {
      const previous = cache.readQuery({ query: GET_PLACE_METRICS });
      const placeMetrics = previous.me.company.placeMetrics.filter(
        v => String(v.id) !== String(input.id)
      );
      const data = {
        me: {
          company: {
            placeMetrics,
          },
        },
      };
      cache.writeQuery({ query: GET_PLACE_METRICS, data });
      return Promise.resolve({
        success: true,
        errors: [],
      });
    },
  },
};
